import bulkTextService from "../../services/bulkTextTransactionService";
import {
    BULK_TEXT_ADD_REQUEST,
    BULK_TEXT_ADD_FAILURE,
    BULK_TEXT_ADD_SUCCESS,
    BULK_TEXT_GET_FAILURE,
    BULK_TEXT_GET_REQUEST,
    BULK_TEXT_GET_SUCCESS,
     } from "./actionTypes";



export const fetchBulkText = (authUserId, token, page, pageSize) => {
   
    return async (dispatch) => {
      dispatch({ type: BULK_TEXT_GET_FAILURE });
      try {
        const response = await bulkTextService.fetchBulkText(authUserId, token, page, pageSize);
        const { data } = response;
        dispatch({ type: BULK_TEXT_GET_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: BULK_TEXT_GET_REQUEST, error: error.message });
        return Promise.reject(error); 
      }
    };
  };

  export const addBulkText = (bulkdata, token) => {
    return async (dispatch) => {
      dispatch({ type: BULK_TEXT_ADD_REQUEST });
      try {
        const response = await bulkTextService.addBulkText(bulkdata, token);
        const { data } = response;
        dispatch({ type: BULK_TEXT_ADD_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: BULK_TEXT_ADD_FAILURE, error: error.message });
        return Promise.reject(error); 
      }
    };
  };


